// Capitalizes the first character in a string
export function capitalize(text) {
    let first = text.charAt(0)
    return first.toUpperCase() + text.slice(1)
}

// Capitalize all words in a string
export function capitalizeWords(text) {
    let capped = text.replace(/ (\w)/g, (match, char) => {
        return ' ' + char.toUpperCase()
    })
    return capitalize(capped)
}

// Un-camel cases a string
// e.g. "camelCaseRules" -> "camel Case Rules"
export function unCamel(text) {
    let space_text = text.replace(/([a-z0-9])([A-Z])/g, (match, lc, uc) => {
        return [lc, uc].join(' ')
    })
    return space_text
}

// Un-snake case a string, retaining original capitalisation
// e.g. "snake_Case_Is_best" -> "snake Case Is best"
export function unSnake(text) {
    return text.replace(/_/g, ' ')
}

// Converts a any_cased_String string into a Capitalised Sentence Case String.
// e.g. "capitalised_sentenceCaseIsBetter" -> "Capitalised Sentence Case Is Better"
export function anyCaseToCapitalisedSentenceCase(text) {
    return capitalizeWords(unCamel(unSnake(text)))
}


// Flattens a list of objects to a list of one attribute of the objects
export function flatten(list, attr) {
    let newlist = []
    for (let item of list) {
        newlist.push(item[attr])
    }
    return newlist
}

// Takes a string, returns it wrapped in a div as a HTML element
// This is needed as vis.js changed how it handles HTML in titles
// https://visjs.github.io/vis-network/examples/network/other/html-in-titles.html
export function stringToElement(my_string) {
    const container = document.createElement("div");
    container.innerHTML = my_string;
    return container;
  }
